import { getCurrentInstance } from '@vue/composition-api';

export function useVuetify() {
  const instance = getCurrentInstance();
  if (!instance) {
    throw new Error(`useVuetify should be called in setup().`);
  }
  return (instance.proxy as any).$vuetify;
}
